import { ESRI, GOOGLE } from '@rsos/constants/mapProviders';
import { getEsriApiKey, getGoogleMapsApiKey } from '@rsos/utils/metaTags';

export const getMapProvider = capabilities => {
  if (capabilities) {
    return ESRI;
  } else {
    return GOOGLE;
  }
};

/**
 * Check if attribution text needs to be updated
 * Only run once after map has been loaded
 * @param {object} map - Esri map instance
 * @param {string} partnerText - name of the partner
 * @param {number} tries - max number of times to retry
 * @param {number} delay - time between each retry
 * @returns Number
 */

export const updateAttributionText = ({ map, partnerText }) => {
  const attribution = map.mapInstance.attribution;

  const updateText = () => {
    attribution.domNode.lastElementChild.style.backdropFilter = 'blur(2px)';
    attribution.domNode.lastElementChild.innerText = `Powered by Esri, ${partnerText}`;
  };
  attribution.when(updateText);
};

export const getMapsApiKey = mapProvider => {
  if (mapProvider === ESRI) {
    return getEsriApiKey();
  } else {
    return getGoogleMapsApiKey();
  }
};
